import { render, staticRenderFns } from "./OptometryHallModify.vue?vue&type=template&id=69174822&scoped=true&"
import script from "./OptometryHallModify.vue?vue&type=script&lang=js&"
export * from "./OptometryHallModify.vue?vue&type=script&lang=js&"
import style0 from "./OptometryHallModify.vue?vue&type=style&index=0&id=69174822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69174822",
  null
  
)

export default component.exports